import { COLORS } from 'constants/index';

const MuiSvgIcon = {
  root: {
    fill: COLORS.BLACK_6,
  }
};

export default MuiSvgIcon;